import React from 'react';
import DownloadSection from '../components/DownloadSection/DownloadSection';
import styles from './NotFound.module.css';

export default function NotFound() {
  return (
    <div className={styles.page}>
      <main className={styles.main}>
        <DownloadSection animate={false} className={styles.download} />
      </main>
      <div className={styles.bg} aria-hidden="true">
        <div className={styles.blobA} />
        <div className={styles.blobB} />
        <div className={styles.noise} />
      </div>
    </div>
  );
}
